<footer class="footer">
	<div class="footer__wrapper">
		<div class="footer__content__wrapper">
			<div class="portal__owner">
				<div class="portal__owner__logo" [routerLink]="['/']">
					<img
						*ngIf="appearance.useTheme && appearance.logo; else defaultLogo"
						[src]="appearance.logo"
						alt="{{ currentStore?.name }} Logo"
					/>

					<ng-template #defaultLogo>
						<img
							class="logo-adv"
							src="assets/images/adv_logo_white.png"
							alt="ADV Tecnologia Logo"
						/>
					</ng-template>
				</div>

				<div
					*ngIf="currentStore; else defaultAddress"
					class="portal__owner__details"
				>
					<small style="text-transform: uppercase">
						{{ currentStore?.corporateName }}
					</small>
					<br />
					<small class="address">
						{{ currentStore?.displayedAddress }}
					</small>
				</div>

				<ng-template #defaultAddress>
					<div class="portal__owner__details">
						<small>
							ADV Tecnologia
							<br />
							Av. Leôncio de Magalhães, nº 209
							<br />
							Jardim São Paulo, São Paulo/SP
							<br />
							CEP 02042-010
						</small>
					</div>
				</ng-template>
			</div>

			<div class="third__party__service">
				<div class="third__party__service__info">
					<small>Desenvolvido por ADV Tecnologia</small>

					<a
						class="third__party__service__logo"
						href="https://www.advtecnologia.com.br/portal-b2b/"
						target="_blank"
						rel="noreferrer noopener"
					>
						<img
							src="assets/images/adv_logo_white.png"
							alt="ADV Tecnologia Logo"
						/>
					</a>
				</div>
			</div>
		</div>
	</div>
</footer>
